import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('WeeklyForAMonth')
export default class WeeklyForAMonth {

  @JsonProperty('start_date', String, false) // Third parameter (optional): isOptional
  public start_date: string
  @JsonProperty('value', Number, false)
  public value: number

  constructor(
        start_date: string,
        value: number,
        ) {
    this.start_date = start_date
    this.value = value
  }
}
